export default class HikingTrailsService {
  static async getTrails(filters = {}) {
    var params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.region) params.append('region', filters.region);
    if (filters.county) params.append('county', filters.county);
    if (filters.managing_agency) params.append('managing_agency', filters.managing_agency);
    if (filters.status) params.append('status', filters.status);
    if (filters.difficulty) params.append('difficulty', filters.difficulty);
    if (filters.source_system) params.append('source_system', filters.source_system);
    if (filters.dogs) params.append('dogs', filters.dogs);
    if (filters.min_elevation) params.append('min_elevation', filters.min_elevation);
    if (filters.max_elevation) params.append('max_elevation', filters.max_elevation);
    if (filters.min_length) params.append('min_length', filters.min_length);
    if (filters.max_length) params.append('max_length', filters.max_length);
    if (filters.min_quality) params.append('min_quality', filters.min_quality);
    if (filters.closures_only) params.append('closures_only', filters.closures_only);
    if (filters.needs_check) params.append('needs_check', filters.needs_check);
    if (filters.allowed_use) params.append('allowed_use', filters.allowed_use);
    if (filters.sort) params.append('sort', filters.sort);
    if (filters.sort_dir) params.append('sort_dir', filters.sort_dir);
    var query = params.toString();
    var url = '/hiking_trails' + (query ? '?' + query : '');
    return fetch(url, { method: 'GET', headers: { Accept: 'application/json' } }).then(function(r) { return r.json(); });
  }

  static async getTrail(id) {
    return fetch('/hiking_trails/' + id, { method: 'GET', headers: { Accept: 'application/json' } }).then(function(r) { return r.json(); });
  }

  static async updateTrail(id, data) {
    return fetch('/hiking_trails/' + id, {
      method: 'PUT',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(function(r) { return r.json(); });
  }

  static async checkStatus(id) {
    return fetch('/hiking_trails/' + id + '/check_status', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    }).then(function(r) { return r.json(); });
  }

  static async predict(id, date) {
    var url = '/hiking_trails/' + id + '/predict' + (date ? '?date=' + date : '');
    return fetch(url, { method: 'GET', headers: { Accept: 'application/json' } }).then(function(r) { return r.json(); });
  }

  static async getClosureHistory(id) {
    return fetch('/hiking_trails/' + id + '/closure_history', { method: 'GET', headers: { Accept: 'application/json' } }).then(function(r) { return r.json(); });
  }

  static async syncAll() {
    return fetch('/hiking_trails/sync_all', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    }).then(function(r) { return r.json(); });
  }

  static async syncCotrex() {
    return fetch('/hiking_trails/sync_cotrex', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    }).then(function(r) { return r.json(); });
  }

  static async syncAlerts() {
    return fetch('/hiking_trails/sync_alerts', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    }).then(function(r) { return r.json(); });
  }

  static async syncDenverWater() {
    return fetch('/hiking_trails/sync_denver_water', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    }).then(function(r) { return r.json(); });
  }

  static async getSyncLog() {
    return fetch('/hiking_trails/sync_log', { method: 'GET', headers: { Accept: 'application/json' } }).then(function(r) { return r.json(); });
  }
}
